import { ComparisonTable, Heading, Text } from "@/design-system";
import { PageSection } from "@/pages/landingPage/components/pageSection";
import type { ComparisonColumn, ComparisonRow } from "../types";

type ComparisonSectionProps = {
  id: string;
  title: string;
  lead?: string;
  caption: string;
  columns: ComparisonColumn[];
  rows: ComparisonRow[];
};

/** Tabela HTML real: o formato que o leitor consulta e o LLM extrai limpo. */
export const ComparisonSection = ({
  id,
  title,
  lead,
  caption,
  columns,
  rows,
}: ComparisonSectionProps) => (
  <PageSection labelledBy={`${id}-title`} className="flex flex-col gap-8">
    <div className="flex flex-col gap-3">
      <Heading level={2} id={`${id}-title`}>
        {title}
      </Heading>
      {lead ? (
        <Text size="lead" tone="muted" className="max-w-2xl">
          {lead}
        </Text>
      ) : null}
    </div>
    <ComparisonTable
      caption={caption}
      captionVisibility="hidden"
      columns={columns}
      rows={rows}
    />
  </PageSection>
);
